/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useState } from 'react';
import { cryptoValue, descryptoValue } from '../libs/crypto';

export default function useLocalStorage(key: any, initialValue: string = '') {
  const [state, setState] = useState(() => {
    
    try {
      const storedValue: any = sessionStorage.getItem(key)

      const value = storedValue && descryptoValue(JSON.parse(storedValue))

      return storedValue ? value : initialValue;
    } catch {
      return initialValue
    }
  });

  const setValue = useCallback((value) => {
    try {
      cryptoValue(value).then((data) => {
        sessionStorage.setItem(key, JSON.stringify(data))
      })
      setState(value);
    } catch (error) {
      console.error(error)
    }
  }, [key]);

  const setRemove = useCallback(() => {
    sessionStorage.removeItem(key);
    setState(initialValue);
  }, [key]);

  return [state, setValue, setRemove];
}

